export default "__VITE_ASSET__B8u8TDav__"